import { captureException } from '@sentry/browser';

import { environment, logging } from '@config';

/** logError
 *
 * @param {*} functionName
 * @returns {Function}
 *
 * Usage
 * .catch(logError(functionName))
 * .catch(logError(functionName, {extraData: 'extraData'}))
 * or
 * catch (error) { logError(functionName)(error) }
 * catch (error) { logError(functionName, {extraData: 'extraData'})(error) }
 */

export function logError (functionName, data = {}) {
  return function logInternalError (error) {
    if (environment.isDevelopment && logging.logLevelDebug) {
      console.error(`Internal Error [${functionName}]`, error);
    }

    if (environment.isProduction) {
      captureException(error, { ...data, functionName });
    }
  };
}

/** logInfo
 *
 * @param {*} functionName
 * @returns {Function}
 *
 * Usage
 * logInfo('Page Load'))
 * logInfo('Page Load', {extraData: 'extraData'}))
 *
 */
export function logInfo (name, data = {}) {
  if (environment.isDevelopment && logging.logLevelInfo) {
    console.info(`Internal Info [${name}]`, data);
  }
}

/** logWarn
 *
 * @param {*} functionName
 * @returns {Function}
 *
 * Usage
 * logWarn('Page is slow'))
 * logWarn('Page is slow', {extraData: 'extraData'}))
 *
 */
export function logWarn (name, data = {}) {
  if (environment.isDevelopment && logging.logLevelInfo) {
    console.warn(`Internal Warn [${name}]`, data);
  }
}
